import React, { useState } from 'react'
import { ImportTouchDesk } from 'modules/ImortTouchDesk'
import { useProfileStore } from 'context/ProfileStore'
import { useHomeStore } from 'context/HomeStore'
import AddEditAccessModal from 'pages/Profile/components/AccessInTheSystem/modals/AddEditAccess.modal'
import CopyAccessesModal from 'pages/Profile/components/AccessInTheSystem/modals/CopyAccesses.modal'
const modalTypes = {
  addEditAccess: 'addEditAccess',
  copyAccess: 'copyAccess'
}
const AccessInTheSystem = () => {
  const { profileStoreFunc, profileStore } = useProfileStore()
  const { homeStore } = useHomeStore()

  const [openModals, setOpenModals] = useState({
    [modalTypes.addEditAccess]: false,
    [modalTypes.copyAccess]: false
  })
  const [tempAccess, setTempAccess] = useState(null)
  const onOpenModal = modal => () =>
    setOpenModals(prevState => ({
      ...prevState,
      [modal]: !prevState[modal]
    }))

  const onEditAccess = access => () => {
    setTempAccess(access)
    onOpenModal(modalTypes.addEditAccess)()
  }
  const onCloseAddEditAccessModal = () => {
    setTempAccess(null)
    onOpenModal(modalTypes.addEditAccess)()
  }
  const onCopyAccess = () => {
    onOpenModal(modalTypes.copyAccess)()
  }

  const findNameBranch = code => {
    const branches = homeStore?.dictionary?.branches || []
    if (branches.length > 0) {
      return branches.find(val => val.code === code)?.name || ''
    }
  }
  const onDeleteAccess = id => () => profileStoreFunc.handleDeleteRole(id)
  const componentProps = {
    roles: profileStore?.user?.roles || [],
    findNameBranch,
    onAddAccess: onOpenModal(modalTypes.addEditAccess),
    onEditAccess,
    onCopyAccess,
    onDeleteAccess
  }

  return (
    <>
      <ImportTouchDesk
        desktop={() => import('./layout/AccessInTheSystem.desktop')}
        touch={() => import('./layout/AccessInTheSystem.mobile')}
      >
        {Component => <Component {...componentProps} />}
      </ImportTouchDesk>
      {openModals[modalTypes.addEditAccess] && (
        <AddEditAccessModal
          onClose={onCloseAddEditAccessModal}
          open={openModals[modalTypes.addEditAccess]}
          tempAccess={tempAccess}
          branchCode={profileStore?.user?.branchCode}
        />
      )}
      {openModals[modalTypes.copyAccess] && (
        <CopyAccessesModal
          onClose={onCopyAccess}
          open={openModals[modalTypes.copyAccess]}
        />
      )}
    </>
  )
}
export default AccessInTheSystem
